import React from "react";

import Switch from "@mui/material/Switch";

export default function SwitchLeftRightOptions(props) {
  const { leftOption, rightOption, id, checked, onChange } = props;

  return (
    <React.Fragment>
      <span style={{ fontVariant: "small-caps" }}>{leftOption}</span>
      <Switch id={id} checked={checked} color="default" onChange={onChange()} />
      <span style={{ fontVariant: "small-caps" }}>{rightOption}</span>
    </React.Fragment>
  );
}
